import { render, staticRenderFns } from "./AA-ArchivesGroup.vue?vue&type=template&id=db62b3ae&scoped=true&"
import script from "./AA-ArchivesGroup.vue?vue&type=script&lang=js&"
export * from "./AA-ArchivesGroup.vue?vue&type=script&lang=js&"
import style0 from "./AA-ArchivesGroup.vue?vue&type=style&index=0&id=db62b3ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db62b3ae",
  null
  
)

export default component.exports